import { FC } from "react";
import { KTCard } from "../../../../../../_metronic/helpers";
import { DetailCard, DetailLabelKeysToCells} from "../../../../../components/layout";

const LABEL_SEARCH_RESULT = {
  serial: "Serial No",
  projectNameAndLocation: "Project Name / Location",
  scdfPlanNo: "SCDF Building Plan No",
  otherRef: "Other Reference",
  state: "Status"
}

type Props ={
    details: any
}


const LabelResultCard: FC<Props> = ({details}) => {
        
    if (! (details && details?.id && details.id > 0)) {
        return (
        <KTCard className="my-6">
            <div className="px-16 py-6 fs-7 text-muted">No results found.</div>
        </KTCard>
        )
    }

    return (
    <div className="my-6">
        <DetailCard cardTitle="Label Details">
            {DetailLabelKeysToCells(LABEL_SEARCH_RESULT, details)}            
        </DetailCard>
    </div>    
    )
}


export {LabelResultCard}
/*
{
    "id": 27821235,
    "serial": "A003002",
    "roiRef": "CB-LB5-00031R",
    "model": "DownTheHatch",
    "size": "22x33(L) 22x3(F)",
    "type": "Bin/linen chute door With Vision Panel (EDL)",
    "hourRating": "2",
    "cocNumber": "FSP-2024-1402",
    "company": "Xarosa Inc",
    "projectNameAndLocation": "LBLR5 Name / LBLR5 Location",
    "scdfPlanNo": "SSS222",
    "otherRef": "D321",
    "state": "VALID"
}
}
*/